import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useOutletContext } from "react-router-dom";
import type { LayoutOutletContext } from "../../components/Layout/Layout";
import ApplicationPermissions from "../../components/ApplicationPermissions";
import { getIdApp } from "../../utils";
import { useButtonTitles } from "./useButtonTitles";
import "./PersonalData.css";

const ApplicationAccess: React.FC = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { theme } = useOutletContext<LayoutOutletContext>();
  const appId = getIdApp() || "";
  const [notice, setNotice] = useState<{ tone: "success" | "error"; text: string } | null>(null);
  const backToSecurityLabel = t("personalData.activeDevices.backToSecurity", { defaultValue: "Back to security" });
  const buttonTitlesRef = useButtonTitles(backToSecurityLabel);

  return (
    <div ref={buttonTitlesRef} className={`pd-shell ${theme === "dark" ? "pd-theme-dark" : "pd-theme-light"}`} data-theme={theme}>
      <div className="pd-shell__noise" />
      <div className="pd-shell__ambient pd-shell__ambient--one" />
      <div className="pd-shell__ambient pd-shell__ambient--two" />

      <div className="pd-dashboard">
        <section className="pd-form-shell pd-glass pd-application-access-panel">
          <div className="pd-form-shell__header">
            <div>
              <h2>{t("personalData.applicationAccess.title")}</h2>
              <p>{t("personalData.applicationAccess.description")}</p>
            </div>
            <div className="pd-topbar__actions">
              <button
                type="button"
                className="pd-secondary-button"
                title={backToSecurityLabel}
                onClick={() => navigate(`/${i18n.language}/personal_data?section=security`)}
              >
                {backToSecurityLabel}
              </button>
            </div>
          </div>

          {notice && (
            <div className={`pd-notice-banner pd-notice-banner--${notice.tone}`}>{notice.text}</div>
          )}

          <ApplicationPermissions ownAppId={appId} onMessage={(tone, text) => setNotice({ tone, text })} />
        </section>
      </div>
    </div>
  );
};

export default ApplicationAccess;
